/**
 * Lightweight Dynamic SEO Helper for SPA page transitions.
 * Ensures Googlebot, Bingbot, and browser tabs always reflect the current page's target keywords.
 */

interface SEOProps {
  title: string;
  description?: string;
  keywords?: string;
  canonicalPath?: string;
}

const DEFAULT_TITLE = 'Jai Bhavani Fireworks | Wholesale Sivakasi Firecrackers Online Store (જય ભવાની ફટાકડા સ્ટોર)';
const DEFAULT_DESC = 'Buy authentic Sivakasi firecrackers online at wholesale factory rates from Jai Bhavani Fireworks. Sparklers, rockets, ground chakkers, sky shots & Diwali gift boxes.';
const BASE_URL = 'https://jaibhavani.store';

export function updatePageSEO({ title, description, keywords, canonicalPath }: SEOProps): void {
  // Update document title
  document.title = title || DEFAULT_TITLE;

  // Update or create meta description
  let metaDesc = document.querySelector('meta[name="description"]');
  if (!metaDesc) {
    metaDesc = document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    document.head.appendChild(metaDesc);
  }
  metaDesc.setAttribute('content', description || DEFAULT_DESC);

  // Update Open Graph Title & Description
  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) ogTitle.setAttribute('content', title || DEFAULT_TITLE);

  let ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) ogDesc.setAttribute('content', description || DEFAULT_DESC);

  // Update Canonical URL
  if (canonicalPath !== undefined) {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    const cleanPath = canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`;
    canonical.setAttribute('href', `${BASE_URL}${cleanPath}`);
  }

  // Update meta keywords if specified
  if (keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', keywords);
  }
}
